import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PersonCardSkeleton = () => (_jsxs("div", { className: "person-card-skeleton animate-pulse", children: [_jsx("div", { className: "person-card-skeleton__circle animate-pulse" }), _jsx("div", { className: "person-card-skeleton__box animate-pulse" })] }));
export default PersonCardSkeleton;
